import { render, staticRenderFns } from "./FormItemVoices.vue?vue&type=template&id=792674e0"
import script from "./FormItemVoices.vue?vue&type=script&lang=js"
export * from "./FormItemVoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports